import React, { useEffect, useRef, useState } from 'react'
import LiveChatPreview from '../../layouts/tenant/LiveChatPreview';
import SendMessengerMessage from './SendMessengerMessage';
import SendWhatsAppMessageView from '../../layouts/tenant/SendWhatsAppMessageView';
import { agentGroupQuery, getChatHistory, getTenantUsers } from '../../store/actions/tenantAction';
import socket from '../../utils/socket';
import { useDispatch, useSelector } from 'react-redux';
import { generateToken } from '../../store/actions/loginAction';
import { useSearchParams } from 'react-router-dom';
import { getInfo, getWaba, LOGIN_INFO, saveWaba, WABA } from '../../utils/types';
import moment from "moment-timezone";
import RightSidePanel from '../../components/RightSidePanel';
import SendTemplateMessageView from '../../layouts/tenant/SendTemplateMessageView';
import { allTags } from '../../utils/helper';
import MobileViewLiveChatHeader from './MobileViewLiveChatHeader';

function LiveChatView() {
    let dispatch = useDispatch();
    const [isConnected, setIsConnected] = useState("");
    const inboxSettingsRef = useRef();
    const [messageList, setMessageList] = useState([]);
    const globalReducer = useSelector((state) => state.globalReducer);
    const [selectedContact, setSelectedContact] = useState({});
    const [canSendMsg, setCanSendMsg] = useState(false);
    const [addNumber, setAddNumber] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [phoneNumbar, setPhoneNumbar] = useState();
    const selectedContactRef = useRef();
    const [searchParams] = useSearchParams();
    const [agents, setAgents] = useState([]);
    const [agentGroup, setAgentGroup] = useState([]);
    const loginInfo = getInfo();

    useEffect(() => {
        dispatch({ type: LOGIN_INFO, payload: loginInfo });
        dispatch({ type: WABA, payload: getWaba() });
        setSelectedContact(JSON.parse(localStorage.getItem("liveChatContact")));
        window.receiveFromFlutter = (d) => {
            const data = typeof d === 'string' ? JSON.parse(d) : d;
            if (data?.contact) {
                setSelectedContact(data?.contact);
            }
            if (data?.waba) {
                saveWaba(data?.waba);
                dispatch({ type: WABA, payload: data?.waba });
            }
        };
    }, []);

    useEffect(() => {
        if (globalReducer?.loginInfo?.tenantId && globalReducer.waba?.id) {
            if (socket?.connected) {
                socket.emit("messageInitiate", {
                    tenantId: globalReducer.loginInfo?.tenantId,
                    wabaId: globalReducer.waba?.id, userUid: globalReducer.loginInfo?.uid
                });
            } else {
                socket.on("connect", () => {
                    setIsConnected(true);
                    socket.emit("messageInitiate", {
                        tenantId: globalReducer.loginInfo?.tenantId,
                        wabaId: globalReducer.waba?.id, userUid: globalReducer.loginInfo?.uid
                    });
                });
            }
            dispatch(getTenantUsers({
                tenantId: globalReducer.loginInfo?.tenantId,
                filter: [{
                    property: "roles",
                    operator: "IN",
                    not: true,
                    value: ["TENANT_SUPER_ADMIN"],
                }],
                size: 10000,
                offset: 0,
                criteria: { active: true },
                orderBy: [{ property: "createdAt", direction: "ASC" }],
            }, a => setAgents(a.data ?? [])));
            dispatch(agentGroupQuery({
                criteria: {
                    tenantId: globalReducer.loginInfo.tenantId,
                    active: true
                },
                tenantId: globalReducer.loginInfo.tenantId,
                size: 10000,
                offset: 0,
                orderBy: [{ property: "createdAt", direction: "ASC" }],
            }, (d) => setAgentGroup(d?.data)));
        }

        socket.on("disconnect", () => setIsConnected(false));

        socket.on("message", (msg) => {
            const msgObj = JSON.parse(msg);
            if (msgObj && msgObj.messageText && msgObj?.contactId === selectedContactRef?.current?.contact?.id) {
                msgObj.messageText = JSON.parse(msgObj.messageText);
                setMessageList((prevMessages) => {
                    const existingIndex = prevMessages.findIndex((m) => m.id && m.id === msgObj.id);
                    if (existingIndex !== -1) {
                        const updated = [...prevMessages];
                        updated[existingIndex] = { ...updated[existingIndex], remarks: msgObj.remarks, reply: msgObj.reply, messageStatus: msgObj.messageStatus };
                        return updated;
                    }
                    return [...prevMessages, msgObj];
                });
                if (msgObj?.type?.toLowerCase() === "text") {
                    setSelectedContact((prev) => {
                        return { ...prev, lastMessage: Array.isArray(msgObj?.messageText) ? msgObj?.messageText[0]?.text?.body : msgObj?.messageText?.text?.body, lastMessageTime: msgObj?.createdAt };
                    });
                }
            }
        });
        return () => {
            socket.off("message");
        };
    }, [globalReducer.loginInfo?.tenantId, globalReducer.waba?.id]);

    useEffect(() => {
        if (globalReducer?.loginInfo?.tenantId && globalReducer?.waba?.id && selectedContact?.id) {
            selectedContactRef.current = selectedContact;
            try {
                dispatch(getChatHistory({
                    filter: [{ property: "messageStatus", operator: "EQ", not: true, value: "blocked" }],
                    criteria: {
                        contactId: selectedContact?.contact?.id,
                        tenantWabaId: globalReducer?.waba?.id
                    }, orderBy: [{ property: "id", direction: "DESC" }],
                    size: 100, offset: 0,
                }, globalReducer.waba?.id, (h) => {
                    if (Array.isArray(h)) {
                        setMessageList(h.map(m => {
                            m.messageText = JSON.parse(m?.messageText);
                            return m;
                        })?.sort((a, b) => moment(a?.createdAt) - moment(b?.createdAt)));
                    }
                }));
            } catch (e) {
                console.error("Error fetching chat history:", e);
            }
            setSelectedTags(allTags?.map(m => { return { text: m.tag, checked: selectedContact?.tags?.includes(m.tag) } }));
        }
    }, selectedContact?.id);

    return (
        <div className="flex border-l border-r flex-col w-full bg-[#F9FAFB]" style={{ height: "100dvh" }}>
            <MobileViewLiveChatHeader setAddNumber={setAddNumber} setSelectedContact={setSelectedContact} agents={agents} agentGroup={agentGroup} selectedContact={selectedContact} selectedTags={selectedTags} setSelectedTags={setSelectedTags} />
            <div className="flex-1 min-h-0 w-full px-1 sm:px-2 pt-1 sm:pt-2 bg-white overflow-auto rounded-[8px]" style={{ backgroundImage: `url("https://live.iomnihub.ai/images/w-icons.png")`, backgroundSize: "auto", backgroundRepeat: "repeat-x", backgroundColor: "#E5DDD5", backgroundBlendMode: "soft-light" }}>
                <LiveChatPreview messageList={messageList} contact={selectedContact} setCanSendMsg={setCanSendMsg} />
            </div>
            <div className="flex-shrink-0 w-full">
                {["MESSENGER", "INSTAGRAM"].includes(selectedContact?.contact?.createdForm) ?
                    <SendMessengerMessage accountType={selectedContact?.contact?.createdForm} isMobileView={true} canSendMsg={canSendMsg} selectedContact={selectedContact} setSelectedContact={setSelectedContact} /> :
                    <SendWhatsAppMessageView accountType={selectedContact?.contact?.createdForm} canSendMsg={canSendMsg} isMobileView={true} selectedContact={selectedContact} setSelectedContact={setSelectedContact} setSendMessageTemplate={(flag) => { setPhoneNumbar(selectedContact?.contact?.whatsappNumber); setAddNumber(flag); }} />
                }
            </div>
            <RightSidePanel ModalTitle="Send Message"
                CustomClass="fixed md:w-[60%] border-l-[1px] top-[30px] right-0 z-[999] height30 transition-transform bg-white"
                isShow={addNumber}
                setIsShow={setAddNumber}
                Component={
                    <SendTemplateMessageView setIsShow={setAddNumber} isLiveChat={true} mobileNumber={phoneNumbar} isMobileView={true} />
                }
            />
        </div>
    )
}

export default LiveChatView